import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { openCallKeys, submissionKeys } from "./queryKeys";
import type { OpenCallSubmission, OpenCallSubmissionPostBody } from "../types";

const createSubmission = (body: OpenCallSubmissionPostBody) =>
  api.post<OpenCallSubmission>("/open-call/submission/create", {
    body: JSON.stringify(body),
  });

const useCreateSubmission = () => {
  const queryClient = useQueryClient();

  return useMutation(createSubmission, {
    onSuccess: (newSubmission) => {
      // Invalidate submission's OpenCall data
      queryClient.invalidateQueries(openCallKeys.detail(newSubmission.id));
      // Manually add submission to OpenCall's submission list
      queryClient.setQueryData<OpenCallSubmission[]>(
        submissionKeys.list({ openCallId: newSubmission.id }),
        (oldData = []) => [...oldData, newSubmission]
      );
      // Invalidate user's submission list
      queryClient.invalidateQueries(
        submissionKeys.user(
          newSubmission.openCallId,
          newSubmission.createdByUserId
        )
      );
    },
  });
};

export { useCreateSubmission };
